import React from 'react';
import logo from '../assets/img/logo.png';
import logo_2x from '../assets/img/logo_2x.png';
import '../assets/fonts/pages-icon/Pages-icon.svg';

const SidebarHeader = (props) => {
  return(
    <div className="sidebar-header">
      <img src={logo} alt="logo" className="brand" data-src={logo} data-src-retina={logo_2x} width="120"/>
      <div className="sidebar-header-controls">
        <button type="button" className="btn btn-link hidden-md-down" data-toggle-pin="sidebar">
        </button>
      </div>
    </div>
  );
}

export default SidebarHeader;
